(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
function alpteqRecentInit(){
document.querySelectorAll('.alpteq-recent').forEach(root=>{
if(root.dataset.alpReady)return;root.dataset.alpReady='true';
const update=()=>root.querySelectorAll('[data-product-handle]').forEach(card=>{
if(!card.classList.contains('grid-product')||card.dataset.alpStyled)return;
card.dataset.alpStyled='true';
const handle=card.dataset.productHandle,link=card.querySelector('.grid-product__link'),title=card.querySelector('.grid-product__title');
if(!link)return;
let destination='',label='';
if(handle.startsWith('faltbare-')){destination='/collections/faltstocke?view=alpteq-falt';label=title?.textContent.split(' - ')[0]+' · Faltstöcke';}
else if(handle.includes('teleskop')||handle.includes('zugspitze')){destination='/collections/teleskopstocke?view=alpteq-teleskop';label=title?.textContent.split(' - ')[0]+' · Teleskopstöcke';}
else if(handle.includes('rastplatz')){destination='/products/'+handle+'?view=alpteq-rastplatz';label='RastPlatz Sitzkissen';}
else if(handle.startsWith('schlafplatz-air')){destination='/products/'+handle+'?view=alpteq-schlafplatz-air';label='SchlafPlatz Air';}
else if(handle.includes('schlafplatz')){destination='/products/'+handle+'?view=alpteq-schlafplatz';label='SchlafPlatz';}
else if(handle.includes('alppak-air-20l')){destination='/products/'+handle+'?view=alpteq-alppak-air';label='AlpPak Air 20L';}
else if(handle.includes('poncho')){destination='/products/'+handle+'?view=alpteq-poncho';label='Emergency Poncho';}
else if(handle.includes('picknickdecke')){destination='/collections/all-products?view=alpteq-picknick';label='Picknickdecke';}
else if(handle.includes('kompression')){label='Kompressionsbags';}
if(destination)link.setAttribute('href',destination);
if(label&&title)title.textContent=label;
const button=document.createElement('span');button.className='ar-button';button.textContent='Auswahl ansehen →';card.querySelector('.grid-product__meta')?.append(button);
});
update();new MutationObserver(update).observe(root,{childList:true,subtree:true});
});
}
document.addEventListener('DOMContentLoaded',alpteqRecentInit);
document.addEventListener('shopify:section:load',alpteqRecentInit);
alpteqRecentInit();

  } catch(e) { console.error(e); }
})();
})();
